<template>
  <div>
    <v-card tile flat>
      <v-layout v-if="services.length > 0" py-5 wrap>
        <v-flex align-self-center text-center xs12>
          <span
            style="
              padding-left: 50px;
              font-family: poppinsbold;
              color: #e7ab5f;
              font-size: 38px;
            "
          >
            Our Major Activities
          </span>
        </v-flex>
      </v-layout>
      <!-- <v-layout justify-center py-2 wrap>
        <v-flex
          align-self-center
          text-center
          v-for="(item, i) in services"
          :key="i"
          xs8
          md6
          lg2
        >
         
          <v-layout wrap justify-space-between fill-height>
            
            <div class="vertical-line"></div>
            <v-flex py-4 px-2 align-self-center>
              <v-card min-height="100" width="200" tile flat>
                <v-layout justify-center wrap fill-height>
                  <v-flex xs12 lg12 align-self-center text-center>
                    <span
                      style="
                        color: #777777;
                        font-family: poppinsbold;
                        font-size: 16px;
                      "
                    >
                      {{ item.name }}
                    </span>
                     
                  </v-flex>
                  
                </v-layout>
              </v-card>
            
            </v-flex>
          </v-layout>
           
        </v-flex>
         
      </v-layout> -->

      <v-layout wrap>
        <template v-for="(item, i) in services">
          <v-flex pa-6 :key="i" md6 xs12 lg3>
            <v-hover v-slot:default="{ hover }" open-delay="200">
              <v-card
                style="cursor: pointer"
               
                :style="hover ? 'transform: scale(1.15)':'transition: transform .2s;'"
                v-if="item.image"
              >
                <v-img
                  alt="Image couldnt load"
                  :src="baseURL + item.image"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="150px"
                >
                  <v-layout wrap fill-height>
                    <v-flex
                      class="overlayShade"
                      text-center
                      align-self-end
                      xs12
                    >
                      <span
                        style="
                          font-family: poppinssemibold;
                          font-size: 16px;
                          color: #ffffff;
                          letter-spacing: 1px;
                        "
                        >{{ item.name }}</span
                      >
                    </v-flex>
                  </v-layout>
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#FF2323"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card>
            </v-hover>
          </v-flex>
        </template>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["about"],
  data() {
    return {
      services: [],
    };
  },
  mounted: function () {
    this.getServices();
  },
  methods: {
    getServices() {
      axios({
        method: "GET",
        url: "/service/providers/list",
      })
        .then((response) => {
          if (response.data.status) var serviceData = {};
          serviceData = response.data.data;
          for (var i = 0; i < serviceData.length; i++) {
            if (serviceData[i].text) {
              this.services.push(serviceData[i]);
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.theme--light.v-divider {
  border-color: rgba(0, 0, 0, 0.12) !important;
}
div.vertical-line {
  width: 1px; /* Line width */
  background-color: #8d8d8d; /* Line color */
  height: 100%; /* Override in-line if you want specific height. */
  float: left; /* Causes the line to float to left of content. 
        You can instead use position:absolute or display:inline-block
        if this fits better with your design */
}
</style>